// JsFromRoutes CacheKey bb477d916f22954b6c5c56627bdd3f34
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  archive: /* #__PURE__ */ definePathHelper('post', '/api/:venue_slug/bookings/:id/archive'),
  unarchive: /* #__PURE__ */ definePathHelper('post', '/api/:venue_slug/bookings/:id/unarchive'),
  recalculateTotals: /* #__PURE__ */ definePathHelper('post', '/api/:venue_slug/bookings/:id/recalculate_totals'),
  calendar: /* #__PURE__ */ definePathHelper('get', '/api/:venue_slug/bookings/calendar'),
  index: /* #__PURE__ */ definePathHelper('get', '/api/:venue_slug/bookings'),
  create: /* #__PURE__ */ definePathHelper('post', '/api/:venue_slug/bookings'),
  show: /* #__PURE__ */ definePathHelper('get', '/api/:venue_slug/bookings/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/api/:venue_slug/bookings/:id'),
}
